import React, { Fragment, useState } from "react";
import { Field, Form, Formik } from "formik";
import * as Yup from "yup";
import LoginInputField from "../../components/forms/login-input-field";
import LoginLogo from "../../assets/icons/login-logo";
import MainContent from "../../components/auth-section/main-content";
import { SignInButton, NavigateButton } from "../../components/buttons/button";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { storeLoginAction } from "../../redux/actions/auth-action";
import errorToast from "../../components/helper-components/error-toast";
import successToast from "../../components/helper-components/success-toast";
import { adminRolesModAction } from "../../redux/actions/general-action";

export default function UserLogin({
  isContainer = true,
  containerClass = "h-full w-screen flex",
}) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const identifyInputType = (input) => {
    if (/^\d{10}$/.test(input)) return "phone"; // Matches a 10-digit phone number
    if (/^[a-zA-Z0-9_]{3,}$/.test(input)) return "username"; // Matches username (alphanumeric, at least 3 chars)
    if (/^\S+@\S+\.\S+$/.test(input)) return "email"; // Matches email format
    return "invalid";
  };
  const initialValues = {
    user_email: "",
    password: "",
    user_check: false,
  };
  const validationSchema = {
    user_input: Yup.string()
      .required("Email, phone number, or username is required")
      .test(
        "is-valid-input",
        "Must be a valid email, phone number, or username",
        (value) => identifyInputType(value) !== "invalid"
      ),
    password: Yup.string()
      .required("Password is required")
      .min(8, "Must be atleast 8 characters long"),
    user_check: Yup.boolean(),
  };
  const Container = isContainer ? "div" : Fragment;

  const onSubmit = (values, { resetForm }) => {
    setLoading(true);
    dispatch(
      storeLoginAction(
        {
          user_email: values?.user_input,
          password: values?.password,
        },
        onSuccess,
        onError
      )
    );
  };
  const onSuccess = (data) => {
    // navigate("/bills");
    successToast(data?.message);
    dispatch(adminRolesModAction(onAdminRolesModSuccess, onAdminRolesModError));
    // window.location.reload(); // Corrected line
  };
  const onError = (data) => {
    setLoading(false);
    errorToast(data?.data?.message);
  };

  const onAdminRolesModSuccess = (data) => {
    setLoading(false);
    const ModPermission = data?.data || [];
    console.log("&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&");
    console.log(ModPermission);
    console.log("&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&");
    localStorage.setItem("ModPermission", JSON.stringify(ModPermission));
        navigate("/bills");
  };
  const onAdminRolesModError = (data) => {};

  return (
    <Container
      {...(isContainer && containerClass ? { className: containerClass } : {})}
    >
      <Formik
        enableReinitialize={true}
        initialValues={initialValues}
        validationSchema={Yup.object(validationSchema)}
        onSubmit={onSubmit}
      >
        {({ values }) => {
          return (
            <Form className="w-1/2 h-screen flex items-center justify-center">
              <div className="flex flex-col gap-5 w-[20rem]">
                <MainContent
                  heading="Sign In"
                  content="Welcome back! Please enter your details."
                />
                <div>
                  <LoginInputField
                    type="text"
                    name="user_input"
                    placeholder="Email, phone number, or username"
                    label="Email, Phone, or Username"
                    isRequired={true}
                  />
                  <LoginInputField
                    type="password"
                    name="password"
                    placeholder="Enter your password"
                    label="Password"
                    isRequired={true}
                    isPasswordEye={true}
                  />
                </div>
                <div className="flex justify-between text-sm">
                  <div className="flex items-center justify-center">
                    <Field
                      type="checkbox"
                      id="remember_checkbox"
                      name="user_check"
                    />
                    <label
                      className="text-344054 ml-2 cursor-pointer"
                      htmlFor="remember_checkbox"
                    >
                      {" "}
                      Remember for 30 days
                    </label>
                  </div>
                  <NavigateButton
                    text="Forgot password?"
                    onclkFn={() => navigate("/forgot-password")}
                  />
                </div>
                <SignInButton loading={loading} text="Sign in" type="submit" />
              </div>
            </Form>
          );
        }}
      </Formik>
      <div className="w-1/2 h-screen bg-F9FAFB">
        <div className="relative flex flex-col items-center justify-center w-full h-screen">
          <div className="mb-12 text-center">
            <div>
              <span className="fs_32 fw_500">
                Nex<span className="fw_200">Tech</span>
              </span>
            </div>
            <div>
              <LoginLogo />
            </div>
          </div>
          <div className="absolute bottom-0 w-full h-1/2  bg-opacity-20 backdrop-blur-md"></div>
        </div>
      </div>
    </Container>
  );
}
